<script lang="ts">
    import Employee from "../../Models/Employee";
    import RolesAutocomplete from "../RolesAutocomplete/RolesAutocomplete.svelte";

    export let open: boolean = false;
    
    let formElement: HTMLFormElement;

    async function handleAddEmployee(e) {
        const formData = new FormData(e.target);
        const data = {
            pin: formData.get('pin'),
            firstname: formData.get('firstname'),
            lastname: formData.get('lastname'),
            phone: formData.get('phone'),
            email: formData.get('email'),
            role: formData.get('role')
        }
        const res = await Employee.add(data);
        if (res) formElement.reset();
        
    }
</script>

<section class="addEmployeeModal">
    <form bind:this={formElement} on:submit|preventDefault={handleAddEmployee} action="">
        <input type="text" name="firstname" placeholder="Imię">
        <input type="text" name="lastname" placeholder="Nazwisko">
        <RolesAutocomplete />
        <small>Wybrana rola wpływa na uprawnienia do działań w aplikacji.</small>
        <input type="phone" name="phone" placeholder="Numer telefonu">
        <small>Pod powyższy numer telefonu wyślemy SMS z danymi dostępowymi do aplikacji.</small>
        <input type="password" name="pin" placeholder="PIN" maxlength="4">
        <input type="email" name="email" placeholder="Adres email">
        <input type="submit" value="Potwierdź i wyślij!">
        <small>Gdy potwierdzisz dodanie użytkownika, automatycznie zostanie on dodany do systemu kawiarni, a na jego numer telefonu prześlemy SMS z zaproszeniem do aplikacji.</small>
    </form>
</section>

<style type="text/scss">
    .addEmployeeModal {
        form {
            display: flex;
            flex-direction: column;

            input {
                outline: none;
                height: 2.25em;

                &[type=password] {
                    width: 50%;
                }

                &[type=phone] {
                    margin: 0;
                }

                &[type=submit] {
                    background: white;
                    border: 1px solid gray;
                    border-radius: 5px;
                    display: flex;
                    margin-top: .25rem;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                }
            }

            small {
                color: gray;
                max-width: 330px;
                font-size: .5rem;
                margin: .5rem 0;
            }
        }
    }
</style>